import axios from "axios";
import axiosInstance from "./axiosInstance";
import { firebaseConfig, firebaseConfigProd, firebaseConfigUAT } from "src/utils/config";
import { urlPrefix } from "src/utils";

export const userInfoService = {
    logout: async (): Promise<void> => {
       const org = localStorage.getItem("organizationName");
       const currentUrl = window.location.origin;
        try {
            localStorage.clear();
            axiosInstance.setAuthToken('');
            if(process.env.REACT_APP_AUTH_EMAIL_PROVIDER === "door-oauth"){
               window.location.href = process.env.REACT_APP_AUTH_REDIRECT_URL + "logout?redirect_uri=" + currentUrl + "&client_id=" + process.env.REACT_APP_CLIENT_ID

            }else {
                if (org) {
                    window.location.href = (`https://${urlPrefix(org)}` + (process.env.REACT_APP_CLOUDOOR_URL || `.dev.gocno.io`)) 
                } else {
                    window.location.href = process.env.REACT_APP_DEFAULT_CLOUDOOR_URL || `https://dev.gocno.io`  
                }
            }

        } catch (error) {
            throw error;
        }
    },


    fetchToken : async (code: string): Promise<any> => {
        try {
            if(process.env.REACT_APP_AUTH_EMAIL_PROVIDER === "door-oauth"){
                const axiosInstanceOauth = axios.create({
                  baseURL: process.env.REACT_APP_API_OAUTH_URL,
                  timeout: 10000,
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",

                  },
                });
                const response = await axiosInstanceOauth.post(`/api/v1/oauth/token`,{
                    grant_type: "authorization_code",
                    code: code,
                });
                return response?.data;
                
            }else {
                if(code !== undefined){
                    const response = await axiosInstance.get(`/api/v1/organizations/users/OauthTokensFromUI?code=${code}`);
                    return response?.data;
                }
            }
            return null;
        } catch (error) {
            window.location.replace(window.location.origin);
            console.log(error);
            throw error;
        }
    },

    refreshToken: async (refreshToken: string | null): Promise<any> => {
        const org = localStorage.getItem("organizationName");
        const currentUrl = window.location.origin;
         if(process.env.REACT_APP_AUTH_EMAIL_PROVIDER === "door-oauth"){
               window.location.href = process.env.REACT_APP_AUTH_REDIRECT_URL + "login?redirect_uri=" + currentUrl + "&client_id=" + process.env.REACT_APP_CLIENT_ID
            }else {
                
            try {
                let data = {
                    grant_type: 'refresh_token',
                    refresh_token: refreshToken,
            };
    
            const googleUrl = 'https://securetoken.googleapis.com';
            return axios.post(googleUrl + '/v1/token?key=' + process.env.REACT_APP_ENV === "productionuat" ? firebaseConfigUAT.apiKey : process.env.REACT_APP_ENV !== "production" ? firebaseConfig.apiKey : firebaseConfigProd.apiKey, data);
                
        } catch (error) {
            const currentUrl = window.location.origin;
             if(process.env.REACT_APP_AUTH_EMAIL_PROVIDER === "door-oauth"){
               window.location.href = process.env.REACT_APP_AUTH_REDIRECT_URL + "login?redirect_uri=" + currentUrl + "&client_id=" + process.env.REACT_APP_CLIENT_ID
            }else {
                if (org) {
                    window.location.href = (`https://${urlPrefix(org)}` + (process.env.REACT_APP_REDIRECT_URL + "?callbackUrl=" + currentUrl))
                } else {
                        window.location.href = process.env.REACT_APP_DEFAULT_REDIRECT_URL + "?callbackUrl=" + currentUrl
                }
            }
                throw error;
            }
        }
    },
    sendNotification : async (label: string, data: any): Promise<any> => {
        const webhookUrl = 'https://hook.eu2.make.com/vo0ilbradki49v2rkvu79seoymqd9tp9';
      
        const message = `Action: Clicked\nButton type: ${label}\n${data}`;
        const payload = {
          text: message,
        };
      
        try {
          const response = await axios.post(webhookUrl, payload, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
          return response.data; // Retour des données de réponse si nécessaire
        } catch (error) {
          console.error('Error sending notification:', error);
          throw error; // Propagation de l'erreur pour la gérer ailleurs
        }
    },
    getUsersInfos: async (): Promise<any> => {
        try {
            const response = await axiosInstance.get(`/api/v1/users/infos`);
            return response.data;
        } catch (error) {
            throw error;
        }
    } 
    
}
